var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isBasicInfoLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isBasicInfoLoading = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('div', {
    staticClass: "card-header -filter_main"
  }, [_c('label', [_vm._v("Create Market Vehicle Request")]), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    attrs: {
      "title": "Back to Requested Market Vehicle List"
    },
    on: {
      "click": _vm.showRequestedMarketVehicleList
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left",
    staticStyle: {
      "font-size": "18px"
    },
    attrs: {
      "style": "font-size: 18px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "form-group row"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Branch Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.branchNameList,
      "clearable": false,
      "name": "branchName",
      "placeholder": "Select Facility Name",
      "label": "text",
      "track-by": "value",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.selectBranchName
    },
    model: {
      value: (_vm.branchName),
      callback: function($$v) {
        _vm.branchName = $$v
      },
      expression: "branchName"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Vehicle Vendor Name ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehiclevendorname),
      expression: "vehiclevendorname"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "vehiclevendorname",
      "id": "vehiclevendorname",
      "placeholder": "Enter Vehicle Vendor Name"
    },
    domProps: {
      "value": (_vm.vehiclevendorname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehiclevendorname = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Vehicle Owner PAN ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicleownerpan),
      expression: "vehicleownerpan"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true,
        regex: /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/
      }),
      expression: "{required: true,  regex:/^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}/}"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "vehicleownerpan",
      "id": "vehicleownerpan",
      "placeholder": "Enter Vehicle Owner PAN",
      "maxlength": "10"
    },
    domProps: {
      "value": (_vm.vehicleownerpan)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicleownerpan = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clientnote notemargin"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v("  Note: Allowed PAN Format ZZZZZ1111Z.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleownerpanError))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Upload Pan Card Photo")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    ref: "files",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "id": "pancardvehiclerequest",
      "name": "pancardvehiclerequest",
      "accept": ".jpeg,.jpg,.png",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.panCardFileUpload($event)
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Type")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    attrs: {
      "multiple": false,
      "max-height": 200,
      "clearable": false,
      "options": _vm.AdhocVehicleList,
      "placeholder": "Select Ad-hoc Vehicle Type",
      "label": "label",
      "track-by": "id",
      "append-to-body": true,
      "name": "AdhocVehicleType"
    },
    on: {
      "select": _vm.selectedVehicleType
    },
    model: {
      value: (_vm.AdhocVehicleType),
      callback: function($$v) {
        _vm.AdhocVehicleType = $$v
      },
      expression: "AdhocVehicleType"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Estimated Vehicle Load ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.estimatedvehicleload),
      expression: "estimatedvehicleload"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "number",
      "name": "estimatedvehicleload",
      "id": "estimatedvehicleload",
      "placeholder": "KG",
      "min": 1
    },
    domProps: {
      "value": (_vm.estimatedvehicleload)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.estimatedvehicleload = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Reason For Ad-hoc Vehicle ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.reasonadhocvehicleList,
      "clearable": false,
      "name": "reasonadhocvehicle",
      "placeholder": "Select Reason",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    on: {
      "select": _vm.onSelectReason
    },
    model: {
      value: (_vm.reasonadhocvehicle),
      callback: function($$v) {
        _vm.reasonadhocvehicle = $$v
      },
      expression: "reasonadhocvehicle"
    }
  })], 1), _vm._v("\n\t\t\t\t\t\t \n\t\t\t\t\t\t"), _c('b-input-group', [(this.reasonremarks == true) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addOtherReasonRemarks),
      expression: "addOtherReasonRemarks"
    }],
    staticStyle: {
      "height": "100px"
    },
    attrs: {
      "name": "remarksdata",
      "id": "remarksdata",
      "cols": "50",
      "rows": "15",
      "placeholder": "Enter Reason Remarks",
      "maxlength": 250
    },
    domProps: {
      "value": (_vm.addOtherReasonRemarks)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addOtherReasonRemarks = $event.target.value
      }
    }
  }) : _vm._e()])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Vehicle Cost (INR) ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehiclecost),
      expression: "vehiclecost"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "min": 1,
      "name": "vehiclecost",
      "id": "vehiclecost",
      "placeholder": "Enter Vehicle Cost"
    },
    domProps: {
      "value": (_vm.vehiclecost)
    },
    on: {
      "keypress": function($event) {
        _vm.isNumber($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehiclecost = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route Name ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('Multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.RouteNamelist,
      "clearable": false,
      "name": "routename",
      "placeholder": "Select Route Name",
      "label": "label",
      "track-by": "id",
      "multiple": false,
      "scroll": true
    },
    model: {
      value: (_vm.routename),
      callback: function($$v) {
        _vm.routename = $$v
      },
      expression: "routename"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Ad-hoc Vehicle Number ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adhocvehiclenumber),
      expression: "adhocvehiclenumber"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "adhocvehiclenumber",
      "id": "adhocvehiclenumber",
      "placeholder": "Enter Ad-hoc Vehicle Number"
    },
    domProps: {
      "value": (_vm.adhocvehiclenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.adhocvehiclenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "vehiclenote"
    }
  }, [_vm._v("Note: Allowed Vehicle Number Format 'XX 00 XX 0000' or 'XX 00 X 0000' or 'XX 00 XXX 0000'.")]), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.vehicleNoErr))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" Upload Proof of Approval ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b-input-group', [_c('input', {
    ref: "files",
    staticStyle: {
      "z-index": "1"
    },
    attrs: {
      "id": "approvalvehiclerequest",
      "name": "approvalvehiclerequest",
      "accept": ".jpeg,.jpg,.png",
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.FileUpload($event)
      }
    }
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-left": "48rem"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button",
      "title": "Submit"
    },
    on: {
      "click": function($event) {
        _vm.createRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Submit")]), _vm._v("   \n\t\t\t"), _c('button', {
    staticClass: "-btn btn-danger",
    attrs: {
      "type": "reset",
      "title": "Reset"
    },
    on: {
      "click": function($event) {
        _vm.resetRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3981b596","hasScoped":true}!./src/modules/firstAndLastmilemanagement/views/marketvehicleflm/createmarketvehiclerequest/createmarketvehiclerequest.component.html
// module id = 1989
// module chunks = 3